<template>
  <div class="demographicOS">
    <adx-list-item :data='data' :type="`bar`" />
  </div>
</template>

<script>
import ListItem from '@/components/ListDemographic'

import api from '@/api'
import { apiV2 } from '@/api/urls'
export default {
  name: 'adx-campaignreport-demographic-OS',
  components: {
    'adx-list-item': ListItem
  },
  props: {

  },
  data() {
    return {
      data: {
        header: ['OPERATING SYSTEM', 'USER'],
        body: []
      }
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    this.loadData()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      const { status, data } = await api.get(apiV2.measurementcampaignReportDetail(this.$route.params.campaign_id), { needToken: true })
      if(status == 200) {
        let { get_all_mobile } = await data
        // get_all_mobile = [
        //   {
        //     'id' : 1,
        //     'name' : "IOS" ,
        //     'percentage' : 0.4
        //   }, 
        //   {
        //     'id' : 2,
        //     'name' : "Android" ,
        //     'percentage' : 0.6
        //   }
        // ]
        let {total_traffic} = await data
        this.data.body = Object.keys(get_all_mobile).map((key, index) => {
          return {
            'name': get_all_mobile[key].name,
            'user': get_all_mobile[key].percentage,
            'total': Math.round(get_all_mobile[key].percentage * total_traffic /100)
          }
        });
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>